import { CustomerApiRecord, CustomerApiResponse, LinkedId, PartialCustomerApiRecord } from './types';
import { serviceHelper } from '../../../../../config/service-helper';
import { UnifiedApiClient } from '../UnifiedApiClient';
import { handleShopifyLogout } from '../../../../../utils/signInOutUp/AuthenticationHelper';

const { unifiedCustomerApi: customerApi } = serviceHelper;

export class CustomerClient extends UnifiedApiClient {
  protected static _refreshUrl = serviceHelper.customerAuthRefresh;
  protected static _logout = handleShopifyLogout;

  static async getCustomer(linkedId: LinkedId, signal?: AbortSignal): Promise<CustomerApiResponse> {
    const { data, statusCode, error } = await this._fetch<CustomerApiRecord>({
      path: `${customerApi}/GetCustomer`,
      method: 'POST',
      body: linkedId,
      signal,
    });
    return { data, statusCode, error };
  }

  static createCustomer = async ({
    mongoCustomerId,
    linkedId,
    primaryPhone,
  }: {
    mongoCustomerId: string;
    linkedId: LinkedId;
    primaryPhone?: string;
  }): Promise<CustomerApiResponse> => {
    const { data, statusCode, error } = await this._fetch<Record<string, any>>({
      path: `${customerApi}/PostCreateCustomer`,
      method: 'POST',
      body: { ...this._localCustomer({ linkedId, primaryPhone }), id: mongoCustomerId },
    });
    return { data: data?.customer as CustomerApiRecord, statusCode, error };
  };

  static updateCustomer = async ({
    customerId,
    updateFields,
  }: {
    customerId: string;
    updateFields: PartialCustomerApiRecord;
  }): Promise<CustomerApiResponse> => {
    const { data, statusCode, error } = await this._fetch<Record<string, any>>({
      path: `${customerApi}/PutUpdateCustomer`,
      method: 'PUT',
      body: { id: customerId, ...updateFields },
    });
    return { data: data?.customer as CustomerApiRecord, statusCode, error };
  };

  static postBirthMonth = async ({
    customerId,
    birthMonth,
  }: {
    customerId: string;
    birthMonth: number;
  }): Promise<CustomerApiResponse> => {
    const { data, statusCode, error } = await this._fetch<CustomerApiRecord>({
      path: `${customerApi}/BirthMonth`,
      method: 'POST',
      body: { customerId: customerId, entityId: 'JBAU', birthMonth },
    });

    return { data: data as CustomerApiRecord, statusCode, error };
  };

  private static _localCustomer = ({
    linkedId,
    primaryPhone,
  }: {
    linkedId: LinkedId;
    primaryPhone?: string;
  }): CustomerApiRecord => {
    return {
      firstName: window.Shopify.Customer.firstName,
      lastName: window.Shopify.Customer.lastName,
      email: window.Shopify.Customer.email,
      acceptsMarketing: window.Shopify.Customer.acceptsMarketing ?? false,
      verifiedEmail: true,
      verifiedPhone: Boolean(primaryPhone),
      primaryPhone: primaryPhone,
      linkedIds: [linkedId],
      createdBy: 'Online',
    };
  };
}
